import React, { useEffect } from "react";
import { MESSAGE_ADDED_EVENT } from "../../../../constants";
import { PresenceSocketService } from "../../../../services/PresenceSocketService";
import { ResponsiveService } from "../../../../services/ResponsiveService";
import { v4 as uuidv4 } from "uuid";
import DateUtils from "../../../../../../services/DateUtils";
import { __, STR_KEY } from "../../../../../../services/Translate";
import { GECKO_CONSTS, GeckoIcon } from "@geckolabs/gecko-react-ui";
import HtmlWrapper from "../../../../../../components/HtmlWrapper";
import DataService from "../../../../services/DataService";
let _message = "";

export const Control = ({ inputRef, replyTo, setReplyTo, replyToMessage }) => {
  useEffect(() => {
    ResponsiveService.chat.ref.input = inputRef;
    const input = inputRef.current;
    // Populate input with previous (and unsent) message
    if (_message) input.value = _message;
    // Store unsent message for later
    return () => (_message = input.value);
  }, []);

  const addMessageFn = (content) => {
    const from = PresenceSocketService.channel().members.me.info.name;
    const isAdmin = PresenceSocketService.channel().members.me.info.is_admin;
    const isHost = PresenceSocketService.channel().members.me.info.is_host;
    // When ADMIN or HOST there is NO contact_uuid
    const contactSecret =
      PresenceSocketService.channel().members.me.info.contact_secret;

    const message = {
      uuid: uuidv4(),
      created_at: DateUtils.utcNow(),
      deleted_at: null,
      content: content.slice(0, 300),
      from: from,
      contact_secret: contactSecret,
      is_admin: isAdmin,
      is_host: isHost,
      reply_to: replyTo,
    };
    // Add to my (and everyone elses) messages array
    PresenceSocketService.trigger(MESSAGE_ADDED_EVENT, message);
    DataService.saveStreamMessage(message);
    setReplyTo(null);
  };

  const inputHandlerFn = (evt) => {
    const input = inputRef.current;
    const check =
      input &&
      (evt.type === "keyup" ? evt.key === "Enter" && input.value : input.value);
    if (check) {
      addMessageFn(input.value);
      // Reset input
      input.value = "";
    }
  };

  return (
    <div className="live-chat-reply-box d-flex position-relative flex-column">
      {replyToMessage && (
        <ReplyMessage {...{ message: replyToMessage, setReplyTo }} />
      )}
      <input
        id="live-chat-reply-box-input"
        type="text"
        className="live-chat-reply-input"
        aria-label={__(STR_KEY.CHAT_TEXTAREA_PLACEHOLDER)}
        placeholder={__(STR_KEY.CHAT_TEXTAREA_PLACEHOLDER)}
        maxLength="300"
        autoComplete="off"
        ref={inputRef}
        onKeyUp={inputHandlerFn.bind(this)}
      />
      <div className="live-chat-reply-box-controls d-flex align-items-center position-absolute">
        <span className="live-chat-reply-box-control-button">
          <i
            id="live-chat-replay-box-button"
            onClick={inputHandlerFn.bind(this)}
            className="far fa-paper-plane"
          ></i>
        </span>
      </div>
    </div>
  );
};

const ReplyMessage = ({ message, setReplyTo }) => {
  return (
    <div
      className={`live-chat-reply-box-reply-message ${
        message.is_admin || message.is_host ? "admin-bg" : ""
      }`}
    >
      <span className="message-sender">
        <GeckoIcon icon={"reply"} style={GECKO_CONSTS.ICON_STYLE_SOLID} />
        &nbsp;Replying to {message.from}
      </span>
      <button
        className="remove-button"
        onClick={() => setReplyTo(null)}
        aria-label={"Remove reply to message"}
      >
        <GeckoIcon icon={"times"} style={GECKO_CONSTS.ICON_STYLE_LIGHT} />
      </button>
      <HtmlWrapper className={"message-content"} html={message.content} />
    </div>
  );
};

export default Control;
